export default "__VITE_ASSET__Tm6C$Au1__"